import React from 'react';
import CRUDDetailPage from '../../../../shared/components/crud/CRUDDetailPage';
import { centerConfig } from '../config/centerConfig';
import { CenterService } from '../../../../shared/services/centerService';

/**
 * CenterDetail - URL-based detail page for Centers
 * Handles view, edit, and add modes with ID from URL params
 */
export default function CenterDetail() {
  return (
    <CRUDDetailPage
      config={centerConfig}
      service={CenterService}
    />
  );
}
